import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Candidate } from '../types/landing';
type CandidateCardProps = {
  candidate: Candidate;
  onOpen: (candidate: Candidate) => void;
};
const tapeTilts = [-4, 3, -2, 5, 2, -5, 4, -3];
export function CandidateCard({
  candidate,
  onOpen
}: CandidateCardProps) {
  const i = (candidate.order - 1) % tapeTilts.length;
  return <motion.button type="button" onClick={() => onOpen(candidate)} initial="rest" animate="rest" whileHover="hover" whileFocus="hover" variants={{
    rest: {
      y: 0
    },
    hover: {
      y: -10
    }
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} aria-label={`Ver perfil de ${candidate.name}`} className="group relative flex h-full w-full flex-col bg-[#FFFEFB] p-3 pb-5 text-left shadow-[0_1px_2px_rgba(40,30,10,0.08),0_10px_24px_-8px_rgba(40,30,10,0.22)] transition-shadow duration-300 hover:shadow-[0_2px_4px_rgba(40,30,10,0.08),0_24px_44px_-12px_rgba(40,30,10,0.32)] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:p-4 sm:pb-6" data-id="element-42" data-mp="2407n558rb304">
      {/* Washi tape */}
      <span aria-hidden className="absolute -top-3 left-1/2 z-10 h-7 w-24 -translate-x-1/2 bg-accent-gold/45 shadow-sm" style={{
      transform: `translateX(-50%) rotate(${tapeTilts[i]}deg)`,
      clipPath: 'polygon(3% 0, 97% 4%, 100% 50%, 96% 100%, 2% 96%, 0 50%)'
    }} data-id="element-43" data-mp="kfsbsm856qv4" />

      {/* Photo */}
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#EEF1F6]" data-id="element-44" data-mp="pen7upv4ebx6">
        <motion.img src={candidate.photo} alt={candidate.name} loading="lazy" variants={{
        rest: {
          scale: 1
        },
        hover: {
          scale: 1.06
        }
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="h-full w-full object-cover object-top" data-id="element-45" data-mp="135i9pi77bsr9" />
        <span aria-hidden className="pointer-events-none absolute inset-0 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.05)]" data-id="element-46" data-mp="186xx3gwuqbct" />
        <motion.span variants={{
        rest: {
          opacity: 0,
          y: 8
        },
        hover: {
          opacity: 1,
          y: 0
        }
      }} transition={{
        duration: 0.25
      }} className="absolute bottom-3 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary px-4 py-2 text-xs font-bold text-white shadow-md" data-id="element-47" data-mp="1fansr92pursv">
          Ver perfil <ArrowUpRightIcon className="h-3.5 w-3.5" data-id="element-48" data-mp="1yxlhjkeq7s1s" />
        </motion.span>
      </div>


      {/* Caption */}
      <div className="flex flex-1 flex-col px-1 pt-5" data-id="element-49" data-mp="22xdxwjad32hp">
        <h3 className="type-h4 text-primary" data-id="element-50" data-mp="27xidm73g3t6v">{candidate.name}</h3>

        <div className="mt-auto pt-4" data-id="element-51" data-mp="27ybbsjoc9ade">
          <div className="flex items-center gap-3 border-t border-dashed border-foreground/15 pt-4" data-id="element-52" data-mp="2cwcv95pofbpe">
            <span className="flex h-16 w-24 shrink-0 items-center justify-center rounded-lg bg-white p-2 ring-1 ring-foreground/10" data-id="element-53" data-mp="djqwkmise71e">
              <img src={candidate.companyLogo} alt="" loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-54" data-mp="ijd8msmvph8m" />
            </span>
            <span className="min-w-0" data-id="element-55" data-mp="66rq7xm6fkbx">
              <span className="block text-[10px] font-bold uppercase tracking-[0.14em] text-foreground/45" data-id="element-56" data-mp="199ey0kost0r">Empresa</span>
              <span className="mt-0.5 block text-[13px] font-semibold leading-snug text-foreground/80" data-id="element-57" data-mp="3sgc30j58aj6r">
                {candidate.company}
              </span>
            </span>
          </div>
        </div>
      </div>
    </motion.button>;
}